// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"b512f583","6445":"09fe7271"}[chunkId] + ".chunk.css";
};